var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgBrandKit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.938 79.268c21.624 0 39.154-17.58 39.154-39.268 0-21.688-17.53-39.27-39.154-39.27C18.313.731.784 18.312.784 40c0 21.687 17.53 39.268 39.154 39.268Z",
    fill: "#EAF1FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m43.824 45.017-5.99-19.52h-4.727l-5.99 19.52-5.933-19.534h-5.436l8.664 28.463h4.415l6.643-20.602 6.617 20.602h4.416l8.664-28.45h-5.41l-5.933 19.521Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.647 54.509a4.48 4.48 0 0 0 4.474-4.487 4.48 4.48 0 0 0-4.474-4.487 4.48 4.48 0 0 0-4.474 4.487 4.48 4.48 0 0 0 4.474 4.487Z",
    fill: "#3585F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandKit);
export default __webpack_public_path__ + "static/media/BrandKit.16f2a402dc9fab513f4637854c7ded85.svg";
export { ForwardRef as ReactComponent };